/* eslint-disable quote-props */
export default {
  'ok': 'Ok',
  'Search': 'Búsqueda',
  'Address': 'Dirección',
  'Routing': 'Ruta',
  'From here': 'Desde aquí',
  'Waypoint here': 'Pasando por aqui',
  'Destination here': 'Hasta aquí',
  'Distance': 'Distancia',
  'Line': 'Línea',
  'Road': 'Carretera',
  'Area': 'Área',
  'fullScreen': 'Pantalla completa',
  'gasStation': 'Gasolinera',
  'gasstations': 'Gasolineras',
  'naturalgasstations': 'Estaciones de gas natural',
  'electricchargers': 'Cargadores eléctricos',
  'detailedLocation': 'Localización detallada',
  'street': 'Calle',
  'city': 'Localidad',
  'postalCode': 'Código postal',
  'municipality': 'Municipio',
  'regionLevel2': 'Provincia',
  'regionLevel1': 'Comunidad',
  'country': 'País',
  'altitude': 'Altitud',
  'maximumSpeed': 'Velocidad máxima',
  'xy': 'Y,X',
  'copy': 'Copiar',
  'go': 'Ir',
  'call': 'Llamar',
  'send:': 'Enviar',
  'calculateIsochrone': 'Calcular isócrona',
  'car': 'Coche',
  'bicycle': 'Bicicleta',
  'onFoot': 'A pie',
  'simplified': 'Simplificada',
  'detailed': 'Detallada',
  'starting': 'Inicio',
  'arrival': 'Llegada',
  'increments': 'Incrementos',
  'maxWeight': 'Peso max.',
  'maxAxleWeight': 'Peso eje max.',
  'maxHeight': 'Altura max.',
  'maxLength': 'Longitud max.',
  'maxWidth': 'Anchura max.',
  'maxSpeed': 'Vel max.',
  'showRoadRestrictions': 'Mostrar restricciones viarias para camiones',
  'dangerousGoods': 'Mercancías peligrosas',
  'trc': 'Código de Restricción de Túnel',
  'trucks': 'Camiones',
  'temporalRestrictions': 'Restricciones temporales',
  'startTime': 'Hora inicio',
  'endTime': 'Hora final',
  'morning': 'Mañana',
  'afternoon': 'Tarde',
  'price': 'Precio',
  'schedule': 'Horario',
  'font': 'Fuente',
  'liveTraffic': 'Tráfico actual',
  'forecastTraffic': 'Tráfico previsto',
  'slow': 'Lento',
  'fast': 'Rápido',
  'roadWorks': 'Obras',
  'AbnormalTraffic': 'Tráfico anormal',
  'queueingTraffic': 'Tráfico con colas',
  'slowTraffic': 'Tráfico lento',
  'stationaryTraffic': 'Tráfico detenido',
  'Accident': 'Accidente',
  'accident': 'Accidente',
  'EnvironmentalObstruction': 'Obstrucción ambiental',
  'flooding': 'Inundación',
  'landslips': 'Deslizamientos de tierra',
  'rockfalls': 'Desprendimientos de rocas',
  'GeneralObstruction': 'Obstrucción general',
  'incident': 'Incidente',
  'objectOnTheRoad': 'Objeto en la carretera',
  'obstructionOnTheRoad': 'Obstrucción en la carretera',
  'shedLoad': 'Pérdida de carga',
  'MaintenanceWorks': 'Trabajos de mantenimiento',
  'maintenanceWork': 'Trabajos de mantenimiento',
  'other': 'Otros',
  'resurfacingWork': 'Trabajos de reasfaltado',
  'MaintenanceWorks roadworks': 'Trabajos de mantenimiento, obras',
  'MaintenanceWorks roadworks, maintenanceWork': 'Trabajos de mantenimiento, obras, trabajos de mantenimiento',
  'roadworks': 'Obras',
  'roadworks, maintenanceWork': 'Obras, trabajos de mantenimiento',
  'roadworks, maintenanceWork, resurfacingWork': 'Obras, trabajos de mantenimiento, trabajos de reasfaltado',
  'roadworks, resurfacingWork': 'Obras, trabajos de reasfaltado',
  'NetworkManagement': 'Gestión de red',
  'contraflow': 'Contraflujo',
  'intermittentShortTermClosures': 'Cierres intermitentes de corta duración',
  'laneOrCarriagewayClosed': 'Carril o calzada cerrada',
  'narrowLanes': 'Carriles estrechos',
  'restrictions': 'Restricciones',
  'roadClosed': 'Carretera cerrada',
  'singleAlternateLineTraffic': 'Tráfico alterno en un solo carril',
  'VehicleObstruction': 'Obstrucción por vehículo',
  'brokenDownVehicle': 'Vehículo averiado',
  'slowMovingMaintenanceVehicle': 'Vehículo de mantenimiento lento',
  'snowplough': 'Quitanieves',
  'vehicleOnFire': 'Vehículo en llamas',
  'obstruction': 'Obstrucción',
  'monday': 'Lunes',
  'tuesday': 'Martes',
  'wednesday': 'Miércoles',
  'thursday': 'Jueves',
  'friday': 'Viernes',
  'saturday': 'Sábado',
  'sunday': 'Domingo',
  'direction': 'Dirección',
  'mapCenter': 'Centro del mapa',
  'maxResults': 'Resultados max.',
  'maxRadius': 'Radio max.',
  'viewOnMap': 'Ver en el mapa',
  'proximity': 'Proximidad',
  'selectCategories': 'Seleccionar categorías',
  'minimizeRoutingMenu': 'Minimizar menú ruta',
  'closeRouteMenu': 'Cerrar menú ruta',
  'writeOrClickMap': 'Escribe o haz click en el mapa',
  'routeTo': 'Hacia...',
  'waypoint': 'Etapa ...',
  'addWaypoint': 'Añadir punto de paso',
  'cleanRoute': 'Limpiar ruta',
  'saveRoute': 'Guardar ruta',
  'printRoute': 'Imprimir ruta',
  'modifyRouteOptions': 'Modificar opciones de ruta',
  'logisticsRoute': 'Ruta para camiones',
  'routeType': 'Tipo ruta',
  'time': 'Tiempo',
  'restTime': 'Tiempo de descanso',
  'distance': 'Distancia',
  'Elevation': 'Elevación',
  'segment_length': 'Longitud segmento',
  'type': 'Tipo',
  'legend': 'Leyenda',
  'avoidTolls': 'Evitar peajes',
  'realtime': 'Tiempo real',
  'optimizedRoute': 'Ruta optimizada',
  'addedCosts': 'Costes añadidos',
  'departureTime': 'Hora de salida',
  'moreDetails': 'Más detalles',
  'routeCar': 'Ruta en coche',
  'routeTruck': 'Ruta en camión',
  'withoutTraffic': 'sin tráfico',
  'ofRest': 'de descanso (tacógrafo)',
  'ZBEInfo': 'Información sobre esta zona de bajas emisiones',
  'hour': 'Hora',
  'roadRestrictions': 'Restricciones de carreteras',
  'addBreakTime': 'Añadir tiempo de descanso (tacógrafo)',
  'twoDrivers': 'Dos conductores',
  'refresh': 'Actualizar',
  'disabled': 'Desactivado',
  'sunLight': 'Iluminación del sol',
  'neighborhoods': 'Barrios',
  'postalcodes': 'Códigos postales',
  'municipalities': 'Municipios',
  'routeStopsFrom': 'Desde:',
  'routeStopsThrought': 'pasando por:',
  'routeStopsTo': 'hacia:',
  'routeStopsTrafficDelay': 'retraso por el tráfico actual',
  'routeSummaryDetails': 'RUTA DETALLADA',
  'routeSummaryTraficJam': 'retraso',
  'searchAddress': 'Dirección',
  'searchPostalCode': 'Código postal',
  'searchCoordinates': 'Coordenadas',
  'searchLocality': 'Localidad',
  'searchPOIs': 'POIs',
  'searchSearchBtn': 'Búsqueda',
  'searchNearestAddress': 'Dirección más cercana',
  'searchSelectCountry': 'Seleccionar país',
  'searchAllCountries': 'Todos los países',
  'searchProjection': 'Proyección',
  'searchXCoordinate': 'Coordenada X',
  'searchYCoordinate': 'Coordenada Y',
  'searchCandidates': 'Candidatos',
  'tooltipAdvancedSearch': 'Búsqueda avanzada',
  'tooltipRouting': 'Calcular ruta',
  'tooltipPois': 'Puntos de interés',
  'tooltipMeteo': 'Predicción meteorológica',
  'tooltipGasStations': 'Gasolineras',
  'tooltipTraffic': 'Tráfico',
  'tooltipZBE': 'Zonas de bajas emisiones',
  'tooltipStreetView': 'Vista de calle',
  'tooltipClean': 'Limpiar mapa',
  'tooltipDraw': 'Dibujar',
  'tooltipLayerSwitcher': 'Cambiar mapa',
  'tooltipLayerRegion': 'Añadir capa administrativa',
  'tooltipLogisticsRestrictions': 'Mostrar restricciones viarias para camiones',
  'tooltipIsochrones': 'Calcular isocronas',
  'tooltipBuildings3D': 'Ver edificios en vista 3D',
  'rainRadar': 'Radar de lluvia',
  'notificationRouteCantGetPosition': 'No se puede obtener su localización. Por favor introduzca la dirección en el formulario de origen.',
  'notificationErrorSavingKML': 'Error guardando KML.',
  'notificationErrorGetPostalCode': 'No se puede obtener el código postal. Error: ',
  'notificationControlAlreadyExists': 'El control ya existe:',
  'notificationSelectCategories': 'Seleccione primero las categorías de puntos de interés.',
  'notificationPoisNotFound': 'Puntos de interés no encontrados.',
  'notificationDrawIsochrone': 'Haz click en el punto del mapa donde quieras calcular la isócrona',
  'notificationErrorGetPathRouting': 'No se ha podido encontrar el camino de la ruta, revise los puntos de paso',

  'assertMapNotDefined': 'Map not defined',
  'assertFeatureExists': 'Feature already exists',
  'assertUnknownBaseLayer': 'Unknown setBaseLayer: ',
  'assertLayerNotSpecified': 'Layer not specified',
  'asserInvalidObjectLonLat': 'Not a \'cercalia.LonLat\' type object',
  'assertUknownWeight': 'Uknown weight: ',
  'assertParameterIsNotFunction': 'Parameter is not a callback function',
  'assertUknownParameter': 'Uknown parameter: ',
  'assertOriginInvalid': 'Can\'t calculate route. Invalid origin: ',
  'assertStepInvalid': 'Can\'t calculate route. Invalid step: ',
  'assertDestinationInvalid': 'Can\'t calculate route. Invalid destination: ',
  'assertProjectionNotDefined': 'Layer projection not declared: ',
  'assertGpsNotPosition': 'Can\'t get GPS position.',
};
